<!-- Airbnb-Style Date Picker Overlay -->
<div *ngIf="show" class="airbnb-date-overlay" [class.mobile-mode]="mode === 'mobile'" (click)="closeModal()">
  <div class="airbnb-date-modal" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="modal-header">
      <h2 class="modal-title">Select date range</h2>
      <button class="close-btn" (click)="closeModal()">
        <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" style="display:block;fill:none;height:16px;width:16px;stroke:currentColor;stroke-width:3;overflow:visible">
          <path d="m6 6 20 20M26 6 6 26"></path>
        </svg>
      </button>
    </div>

    <!-- Dual Calendar View for Desktop -->
    <div class="calendar-container" *ngIf="mode === 'desktop'" (mouseleave)="clearHover()">
      <!-- Previous Month Calendar -->
      <div class="calendar-month">
        <div class="month-header">
          <button class="nav-btn" (click)="previousMonth()">
            <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" style="display:block;fill:none;height:12px;width:12px;stroke:currentColor;stroke-width:4;overflow:visible">
              <path fill="none" d="M20 28 8.7 16.7a1 1 0 0 1 0-1.4L20 4"></path>
            </svg>
          </button>
          <h3>{{ getPreviousMonthLabel() }}</h3>
          <div class="nav-spacer"></div>
        </div>
        <div class="weekday-labels">
          <div *ngFor="let day of weekDays" class="weekday">{{ day }}</div>
        </div>
        <div class="days-grid">
          <div *ngFor="let day of previousMonthDays" 
               class="day-cell"
               [class.disabled]="!day.enabled"
               [class.selected]="isSelected(day)"
               [class.range-start]="isRangeStart(day)"
               [class.show-start-bg]="shouldShowStartBackground(day)"
               [class.range-end]="isRangeEnd(day)"
               [class.hovered-end]="isHoveredEnd(day)"
               [class.in-range]="isInRange(day)"
               [class.first-day-of-month]="isFirstDayOfMonth(day)"
               [class.last-day-of-month]="isLastDayOfMonth(day)"
               [class.is-sunday]="isSunday(day)"
               [class.is-saturday]="isSaturday(day)"
               [class.today]="isToday(day)"
               (click)="selectDate(day)"
               (mouseenter)="hoverDate(day)">
            <span *ngIf="day.date">{{ day.date }}</span>
          </div>
        </div>
      </div>

      <!-- Current Month Calendar -->
      <div class="calendar-month">
        <div class="month-header">
          <div class="nav-spacer"></div>
          <h3>{{ getCurrentMonthLabel() }}</h3>
          <button class="nav-btn" (click)="nextMonth()" [disabled]="!canGoToNextMonth()" [class.disabled]="!canGoToNextMonth()">
            <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" style="display:block;fill:none;height:12px;width:12px;stroke:currentColor;stroke-width:4;overflow:visible">
              <path fill="none" d="m12 4 11.3 11.3a1 1 0 0 1 0 1.4L12 28"></path>
            </svg>
          </button>
        </div>
        <div class="weekday-labels">
          <div *ngFor="let day of weekDays" class="weekday">{{ day }}</div>
        </div>
        <div class="days-grid">
          <div *ngFor="let day of currentMonthDays" 
               class="day-cell"
               [class.disabled]="!day.enabled"
               [class.selected]="isSelected(day)"
               [class.range-start]="isRangeStart(day)"
               [class.show-start-bg]="shouldShowStartBackground(day)"
               [class.range-end]="isRangeEnd(day)"
               [class.hovered-end]="isHoveredEnd(day)"
               [class.in-range]="isInRange(day)"
               [class.first-day-of-month]="isFirstDayOfMonth(day)"
               [class.last-day-of-month]="isLastDayOfMonth(day)"
               [class.is-sunday]="isSunday(day)"
               [class.is-saturday]="isSaturday(day)"
               [class.today]="isToday(day)"
               (click)="selectDate(day)"
               (mouseenter)="hoverDate(day)">
            <span *ngIf="day.date">{{ day.date }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Single Calendar View for Mobile -->
    <div class="calendar-container" *ngIf="mode === 'mobile'" (mouseleave)="clearHover()">
      <div class="calendar-month">
        <div class="month-header">
          <button class="nav-btn" (click)="previousMonth()">
            <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" style="display:block;fill:none;height:12px;width:12px;stroke:currentColor;stroke-width:4;overflow:visible">
              <path fill="none" d="M20 28 8.7 16.7a1 1 0 0 1 0-1.4L20 4"></path>
            </svg>
          </button>
          <h3>{{ getCurrentMonthLabel() }}</h3>
          <button class="nav-btn" (click)="nextMonth()" [disabled]="!canGoToNextMonth()" [class.disabled]="!canGoToNextMonth()">
            <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" style="display:block;fill:none;height:12px;width:12px;stroke:currentColor;stroke-width:4;overflow:visible">
              <path fill="none" d="m12 4 11.3 11.3a1 1 0 0 1 0 1.4L12 28"></path>
            </svg>
          </button>
        </div>
        <div class="weekday-labels">
          <div *ngFor="let day of weekDays" class="weekday">{{ day }}</div>
        </div>
        <div class="days-grid">
          <div *ngFor="let day of currentMonthDays" 
               class="day-cell"
               [class.disabled]="!day.enabled"
               [class.selected]="isSelected(day)"
               [class.range-start]="isRangeStart(day)"
               [class.show-start-bg]="shouldShowStartBackground(day)"
               [class.range-end]="isRangeEnd(day)"
               [class.in-range]="isInRange(day)"
               [class.first-day-of-month]="isFirstDayOfMonth(day)"
               [class.last-day-of-month]="isLastDayOfMonth(day)"
               [class.is-sunday]="isSunday(day)"
               [class.is-saturday]="isSaturday(day)"
               [class.today]="isToday(day)"
               (click)="selectDate(day)">
            <span *ngIf="day.date">{{ day.date }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer Actions -->
    <div class="modal-footer">
      <button class="clear-btn" (click)="clearDates()">Clear dates</button>
      <button class="apply-btn" 
              [disabled]="!isValidRange"
              (click)="applyDates()">
        Apply
      </button>
    </div>
  </div>
</div>
